import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { VaultAssignment } from "@/types/billing";

interface VaultTargetPickerProps {
  targetType: VaultAssignment["targetType"];
  targetId: string;
  onTargetIdChange: (targetId: string) => void;
}

const PLACEHOLDER_BY_TYPE: Record<VaultAssignment["targetType"], string> = {
  user: "User ID",
  group: "Group ID",
  app: "App ID",
  agent: "Agent ID",
  project: "Project ID",
  page: "Page ID",
  org: "Organization ID",
};

export const VaultTargetPicker: React.FC<VaultTargetPickerProps> = ({
  targetType,
  targetId,
  onTargetIdChange,
}) => (
  <div className="space-y-2">
    <Label htmlFor="assign-target-id">{PLACEHOLDER_BY_TYPE[targetType]}</Label>
    <Input
      id="assign-target-id"
      placeholder={PLACEHOLDER_BY_TYPE[targetType]}
      value={targetId}
      onChange={(event) => onTargetIdChange(event.target.value)}
    />
  </div>
);
